import { useSelector } from "react-redux";
import { ObjectTarget } from "../../../app/permissions";
import { Badge, Box, Typography } from "@mui/material";
import { ConversationInfo, ConversationMessage } from "../../../redux/conversation/conversationSlice";
import { getOrRetrieveNamedObject, ObjectRetrieveRequest, selectObjectCache } from "../../../redux/object/objectCacheSlice";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../app/hooks";
import { NamedObject } from "../../../redux/object/namedObject";
import { MessageType } from "../../../redux/conversation/messageListSlice";

interface MessageTileSystemProps {
    conversation: ConversationInfo;
    message: ConversationMessage;
}

export const MessageTileSystem = (props: MessageTileSystemProps) => {
    const msg = props.message;
    const dispatch = useAppDispatch();
    const objectCache = useSelector(selectObjectCache);

    const [systemUserActor, setSystemUserActor] = useState(undefined as undefined | NamedObject);

    useEffect(() => {
        switch (msg.messageType) {
            case MessageType.PARTY_JOINED:
            case MessageType.PARTY_LEFT: {
                if(!msg.text) {
                    console.warn("MessageTileSystem: message text is empty for message type", msg.messageType);
                    return;
                }
                const chunks = msg.text.trim().split(":");
                if (chunks.length < 2) {
                    console.warn("MessageTileSystem: message text does not contain a valid party ID", msg.text);
                    return;
                }
                const reqParty: ObjectRetrieveRequest = {
                    objectTarget: parseInt(chunks[0].trim()) as ObjectTarget,
                    targetId: chunks[1].trim()
                };
                const fndObjParty = getOrRetrieveNamedObject(dispatch, objectCache, reqParty.objectTarget, reqParty.targetId);
                if(fndObjParty) {
                    setSystemUserActor( fndObjParty );
                }
                break;
            }
            case MessageType.USER_JOINED:
            case MessageType.USER_LEFT: {
                if(!msg.text) {
                    console.warn("MessageTileSystem: message text is empty for message type", msg.messageType);
                    return;
                }
                const reqUser: ObjectRetrieveRequest = {
                    objectTarget: ObjectTarget.USER,
                    targetId: `${msg.text}`
                };
                const fndObjUser = getOrRetrieveNamedObject(dispatch, objectCache, reqUser.objectTarget, reqUser.targetId);
                if(fndObjUser) {
                    setSystemUserActor( fndObjUser );
                }
                break;
            }
        }
    }, [objectCache, msg.text]);

    let message = `${msg.messageType}`;
    let color = "#CCCCCC";
    switch (msg.messageType) {
        case MessageType.PARTY_JOINED:
            color = "#CCFFCC";
            if(systemUserActor) {
                message = `${systemUserActor.display} adicionado à conversa`;
            } else {
                message = "Participante adicionado à conversa";
            }
            break;
        case MessageType.PARTY_LEFT:
            color = "#FFCCCC";
            if(systemUserActor) {
                message = `${systemUserActor.display} removido da conversa`;
            } else {
                message = "Participante removido da conversa";
            }
            break;
        case MessageType.USER_JOINED:
            color = "#CCFFCC";
            if(systemUserActor) {
                message = `${systemUserActor.display} adicionado à conversa`;
            } else {
                message = "Usuario adicionado à conversa";
            }
            break;
        case MessageType.USER_LEFT:
            color = "#FFCCCC";
            if(systemUserActor) {
                message = `${systemUserActor.display} removido da conversa`;
            } else {
                message = "Usuario removido da conversa";
            }
            break;
        case MessageType.SURVEY_ANSWER:
            message = "Usuário respondeu à pesquisa";
            color = "#CCCCFF";
            break;
        case MessageType.MESSAGE_DISMISSED:
            message = "Mensagem marcada como lida";
            color = "#DDDDFF";
            break;
        case MessageType.DELETE:
            message = "Mensagem apagada";
            color = "#DDDDDD";
            break;
        case MessageType.CHANGED:
            message = "Mensagem alterada";
            color = "#DDDDDD";
            break;
        default:
            message = `Mensagem não suportada. #${msg.messageType}`;
            color = "#CCCCCC";
            break;
    }

    return <Box sx={{ padding: "0px", textAlign: "center", marginY: "2px" }}>
        <Badge sx={{ backgroundColor: color, paddingY: "0px", paddingX: "10px", border: "1px solid gray", borderRadius: 1 }}>
            <Typography variant="body2" sx={{ fontStyle: "italic", fontSize: "0.7rem" }}>
                {message}
            </Typography>
        </Badge>
    </Box>
    ;

};